import React from "react";

import {formatPriceCent, parsePrice} from "../RatePlanner";

import TextField from "@mui/material/TextField/TextField";
import InputAdornment from "@mui/material/InputAdornment";


const PriceTag = (props) => {

    const {formik, ratesViewMode, people} = props;

    const getPriceValue = (value) => {
        // check if value is a valid number (The value might be null or INDETERMINATE)
        if (Number.isFinite(value)) {
            return formatPriceCent(value, people, ratesViewMode);
        }else{
            return '';
        }
    }

    const handlePriceChange = (e) => {
        const value = parseFloat(e.target.value);
        // check if value is a number
        if ( Number.isFinite(value)) {
            formik.setFieldValue(`pricesCent[${people}]`, parsePrice(value, people, ratesViewMode));
        }else{
            formik.setFieldValue(`pricesCent[${people}]`, null);
        }
    }

    return <TextField type="number"
                      placeholder="----.--"
                      label={`Prezzo valido per ${people} persone`}
                      fullWidth
                      name={`pricesCent[${people}]`}
                      value={getPriceValue(formik.values.pricesCent[people])}
                      onChange={handlePriceChange}
                      error={formik.touched.pricesCent?.[people] && Boolean(formik.errors.pricesCent?.[people])}
                      helperText={formik.touched.pricesCent?.[people] && formik.errors.pricesCent?.[people]}
                      inputProps={{sx: {textAlign: "right"}}}
                      InputProps={{
                          startAdornment: <InputAdornment position="start">
                              {ratesViewMode === "person" ? "Prezzo per persona a notte" : "Prezzo totale a notte"}
                          </InputAdornment>,
                          endAdornment: <InputAdornment position="end">€</InputAdornment>,
                      }}
    />
}

export default PriceTag;